import { not } from '@fmnts/core';
import { ConditionFn } from '../condition.type';

export interface ConditionNegate {
  /**
   * Flag that can be used to negate the condition behaviour.
   */
  negate: boolean;
}

/**
 * Type guard that checks if an object fulfills the `ConditionNegate` interface
 *
 * @param c Non nullish object
 * @returns `true` if `c` satisfies `ConditionNegate`
 */
export function isConditionNegate(
  c: Record<string, any>,
): c is ConditionNegate {
  return typeof c['negate'] === 'boolean';
}

/**
 * @param condition Condition configuration
 * @param fn The original function
 *
 * @returns
 * A new condition function from the given `fn`
 * that negates it's fulfillment based on the
 * conditions `negate` flag
 */
export function negate<T>(
  condition: ConditionNegate,
  fn: ConditionFn<T>,
): (value: T) => boolean {
  const { negate: shouldNegate } = condition;
  return shouldNegate ? not(fn) : fn;
}
